import handler from 'api/handler'

const prefix = '/admin/analytics'

const analytics = {
  fetchList: args => handler({ method: 'get', url: `${prefix}/list`, args }),
  fetchSummary: args => handler({ method: 'get', url: `${prefix}/summary`, args }),
  fetchOverview: args => handler({ method: 'get', url: `${prefix}/overview`, args }),
  lookupUser: args => handler({ method: 'get', url: `${prefix}/userLookup`, args }),
  fetchReferrals: args => handler({ method: 'get', url: `${prefix}/referrals`, args })
}

export default analytics

